import { resolveMultirateLowFilter } from 'custom_hooks/data_hooks/data_source/dataPlatformIndicatorDataSource';

export function isLowFreqCollectionOnlySelected(collectionFilter: boolean[]): boolean {
    const resolved = resolveMultirateLowFilter(collectionFilter);
    return resolved.kind === 'filter' && resolved.value === true;
}

export function getLowFreqEmptyStateMessage(isEnvelopedSelected: boolean): string {
    return isEnvelopedSelected
        ? 'Low frequency and enveloped data are only available on equipment monitored by V4 sensors.'
        : 'Low frequency data is only available on equipment monitored by V4 sensors.';
}

export function isLowFreqCollectionUnsupported({
    areV4SensorsInScope,
    isLoadingAreV4SensorsInScope,
}: Readonly<{
    areV4SensorsInScope: boolean | undefined;
    isLoadingAreV4SensorsInScope: boolean;
}>): boolean {
    return !isLoadingAreV4SensorsInScope && areV4SensorsInScope === false;
}

export type QuickFilter =
    | 'rms-accel'
    | 'peak-accel'
    | 'peak-vel'
    | 'rms-vel'
    | 'overall-vib'
    | 'vib-bands'
    | 'voltage'
    | 'temp'
    | 'signal-strength'
    | 'ultrasound';

export const DefaultQuickFilters: QuickFilter[] = ['peak-accel', 'rms-vel', 'temp'];
